import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { GetProductMergeDefaults, GetProductMergeDefaultsVariables }
  from '@/graphql/contracts/_generated_/getProductMergeDefaults.query';
import { notificationService } from '@/services/notification/notification.client';
import GetProductMergeDefaultsQuery from '@/graphql/contracts/getProductMergeDefaults.query.gql';

export default function useGetProductMergeDefaults() {
  const [_getProductMergeDefaults, { loading, error, data }] = useLazyQuery<
  GetProductMergeDefaults,
  GetProductMergeDefaultsVariables
  >(GetProductMergeDefaultsQuery, {
    client: apolloClientContracts,
    fetchPolicy: 'network-only',
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });

  const getProductMergeDefaults = async () => {
    const response = await _getProductMergeDefaults();
    return response.data?.getProductMergeDefaults;
  };

  return {
    getProductMergeDefaults,
    productMergeDefaults: data?.getProductMergeDefaults,
    isLoadingProductMergeDefaults: loading,
    errorProductMergeDefaults: error,
  } as const;
}
